var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.313,
    height: 16.323,
    viewBox: "0 0 16.313 16.323",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-refresh",
    "data-name": "Icon material-refresh",
    d: "M19.931,8.4a8.163,8.163,0,1,0,2.122,7.8H19.931A6.118,6.118,0,1,1,14.166,8.04a6.034,6.034,0,0,1,4.305,1.816l-3.285,3.285h7.141V6Z",
    transform: "translate(-6.015 -6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.137ec0beacb04b8ecb58ca99d849f1dc.svg";
export { ForwardRef as ReactComponent };